<template>
    <footer class="footer mt-auto py-3 bg-light">
  <div class="container text-end">
    Genderful Research World ©2022 
  </div>
</footer>
</template>